export const PageDataState = {
    Searchs: {
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        },
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            placeholder: 'ตำแหน่ง'
        }, 
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            placeholder: 'อุตสาหกรรม'
        },   
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            placeholder: 'ปี'
        },                        
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        description: {
            type: 'textarea',
            rows: 5,
            id: 'description',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },   
        positions: {
            type: 'text',
            id: 'positions',
            label: 'ความต้องการ',
            value: '',
            placeholder: 'ความต้องการแรงงาน',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 100000,
            },
            error: { status: null, msg: '' }
        }, 
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },                               
    },
    InputGroup: {}        
}